import * as React from 'react';
import * as style from './StickyBottomLayout.css';

export const StickyBottomLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={style['container']}>{children}</div>;
};
